<template lang="pug">
  .preorder
    table.table
      tr
        th.row-label
          .label {{ matrix.labels.row }}
        th.col-label(v-for="col in colProp.options")
          .label {{ col.value }}
      tr(v-for="(row, i) in matrix.rows")
        th.vertical-label
          .row-label-cell
            .colorimage-cell(
              v-if="row.image && row.image.src"
              :style="{ backgroundImage: 'url(' + row.image.src + ')'}"
            )
            span.label {{ row.label }}
        td(v-for="col in row.columns")
          PreorderArticle(
            :article="col.article"
            :valid="valid"
            :manageStock="manageStock"
          )
          //- button.button.is-small.is-link(
          //-   :class="{ 'is-active': col.article && col.article.id === activeArticleId, 'is-out-of-stock': manageStock && col.article && !col.article.qty_sum }"
          //-   :disabled="!col.article || (manageStock && !col.article.qty_sum)"
          //-   @click="selectArticle(row, col)"
          //- ) {{ col.label }}
</template>

<script>
import Matrix from './Matrix';
import PreorderArticle from './PreorderArticle';

export default {
    name: 'Preorder',
    extends: Matrix,
    components: {
        PreorderArticle
    }
};
</script>

<style lang="sass" scoped>
.preorder
  // margin: -2px
table
  @apply border-1 w-full
  border-spacing: 0
  border-collapse: separate
  .row-label-cell
    display: flex
    align-items: center
    .label
      line-height: 1

    .colorimage-cell
      margin-right: 4px
      padding: 0 !important
      width: 30px
      height: 30px
      background-position: center
      background-size: cover
      background-repeat: no-repeat

  td, th
    @apply border-1 border-r-0 border-b-0 p-1
    &:first-child
      @apply border-l-0
  tr:first-of-type
    td, th
      @apply border-t-0

  tr.hr td
    padding-top: 0.5rem

  td.has-button
    width: 1px

  .label
    @apply font-medium

  .buttons
    margin: 0 -2px
    .button
      margin: 0 2px

  .vertical-label
    padding-right: calc(1rem - 2px)
    white-space: nowrap
    width: 120px

  .row-label,
  .col-label
    @apply text-center p-2 bg-gray-100
</style>
